import UserEmailAddress from './UserEmailAddress';

export default UserEmailAddress;
